import { render, staticRenderFns } from "./logOut.vue?vue&type=template&id=04d81a8b&scoped=true"
import script from "./logOut.vue?vue&type=script&lang=js"
export * from "./logOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d81a8b",
  null
  
)

export default component.exports